import React, { createContext, useContext } from "react"

const ProductsFiltersContext = createContext()

const available_filters = [
  "paKartaGraficznas",
  "paKlasaProduktus",
  "paPamiecRams",
  "paProcesors",
  "paProducents",
  "paPrzekatnaEkranus",
  "paSystemOperacyjnies",
]

const getFilterTitle = key => {
  switch (key) {
    case "paKartaGraficznas":
      return "Karta graficzna"
    case "paKlasaProduktus":
      return "Klasa produktu"
    case "paPamiecRams":
      return "Pamięć RAM"
    case "paProcesors":
      return "Procesor"
    case "paProducents":
      return "Producent"
    case "paPrzekatnaEkranus":
      return "Przekątna ekranu"
    case "paSystemOperacyjnies":
      return "System operacyjny"
    default:
      return ""
  }
}

function ProductsFiltersProvider({
  children,
  all_products,
  filterProductsByQueryFilters,
  query,
  setQuery,
}) {
  const createFilters = () => {
    const filters = {}
    try {
      for (const product of all_products) {
        for (const key in product) {
          if (available_filters.includes(key)) {
            if (product?.[key]?.nodes.length > 0) {
              for (const node_key of product[key].nodes) {
                if (filters[key]) {
                  let { options } = filters[key]
                  const option_index = options.indexOf(
                    options.find(({ name }) => name === node_key?.name)
                  )
                  if (option_index < 0) {
                    options = [
                      ...options,
                      {
                        name: node_key?.name,
                        count: filterProductsByQueryFilters(
                          all_products,
                          Object.keys(query)
                            .filter(query_key => query_key !== key)
                            .map(key => (query?.[key]?.length > 0 ? key : null))
                            .filter(Boolean)
                        ).filter(product =>
                          product[key].nodes.find(
                            ({ name }) => name === node_key?.name
                          )
                        ).length,
                      },
                    ]
                  }
                  filters[key] = {
                    ...filters[key],
                    options,
                  }
                } else {
                  filters[key] = {
                    title: getFilterTitle(key),
                    options: [
                      {
                        name: node_key?.name,
                        count: filterProductsByQueryFilters(
                          all_products,
                          Object.keys(query)
                            .filter(query_key => query_key !== key)
                            .map(key => (query?.[key]?.length > 0 ? key : null))
                            .filter(Boolean)
                        ).filter(product =>
                          product[key].nodes.find(
                            ({ name }) => name === node_key?.name
                          )
                        ).length,
                      },
                    ],
                  }
                }
              }
            }
          }
        }
      }
      
      return Object.keys(filters).map(key => ({ ...filters[key], id: key }))
    } catch (error) {
      return []
    }
  }

  const filters = createFilters()
  return (
    <ProductsFiltersContext.Provider value={{ filters, query, setQuery }}>
      {children}
    </ProductsFiltersContext.Provider>
  )
}

const useProductsFilters = () => useContext(ProductsFiltersContext)
export { ProductsFiltersContext, useProductsFilters }
export default ProductsFiltersProvider
